import React, { useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";
import Navbar from "../components/Navbar";
import Sidebar from "../pages/Sidebar/Sidebar";
import Footer from "../pages/Footer/Footer";
import Users from "./Users";
import Guards from "./Guards";
import Reports from "./Reports";
import Society from "./Society";
import CreateStaff from "./CreateStaff";
import AllStaff from "./AllStaff";
import StaffAttendence from "./StaffAttendence";
import "./AdminPage.css";

const AdminPage = () => {
  const [counts, setCounts] = useState({
    users: null,
    guards: null,
    society: null,
    staff: null,
  });

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const loadStats = async () => {
      try {
        const token = localStorage.getItem("token");

        const res = await fetch(
          "https://gateguard.cloud/api/admin/api/admin/stats",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const data = await res.json();

        setCounts({
          users: data.users,
          guards: data.guards,
          society: data.society,
          staff: data.staff,
        });
      } catch (err) {
        setError("Failed to load statistics");
      } finally {
        setLoading(false);
      }
    };

    loadStats();
  }, []);

  return (
    <div className="admin-container">
      <Navbar />

      <div className="admin-body">
        <Sidebar />

        <main className="admin-main">
          <Routes>
            <Route
              path="/"
              element={
                <>
                  <div className="heading-text">
                    <h1>Welcome, Admin!</h1>
                    <p>Manage users, guards, staff, and societies below.</p>
                  </div>

                  <div className="cards-container">
                    {/* Users */}
                    <div className="card stat-card">
                      <div className="icon-container user-icon">
                        <i className="fas fa-user"></i>
                      </div>
                      <p className="stat-number">
                        {loading ? "Loading..." : counts.users}
                      </p>
                      <p className="stat-label">Users</p>
                    </div>

                    {/* Guards */}
                    <div className="card stat-card">
                      <div className="icon-container guard-icon">
                        <i className="fas fa-shield-alt"></i>
                      </div>
                      <p className="stat-number">
                        {loading ? "Loading..." : counts.guards}
                      </p>
                      <p className="stat-label">Guards</p>
                    </div>

                    {/* Society */}
                    <div className="card stat-card">
                      <div className="icon-container society-icon">
                        <i className="fas fa-building"></i>
                      </div>
                      <p className="stat-number">
                        {loading ? "Loading..." : counts.society}
                      </p>
                      <p className="stat-label">Societies</p>
                    </div>

                    {/* Staff (new) */}
                    <div className="card stat-card">
                      <div className="icon-container staff-icon">
                        <i className="fas fa-users-cog"></i>
                      </div>
                      <p className="stat-number">
                        {loading ? "Loading..." : counts.staff}
                      </p>
                      <p className="stat-label">Staff</p>
                    </div>
                  </div>

                  <div className="interactive-3d">
                    <p>??? Interactive Security Globe</p>
                  </div>
                </>
              }
            />

            <Route path="/users" element={<Users />} />
            <Route path="/guards" element={<Guards />} />
            <Route path="/society" element={<Society />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/createstaff" element={<CreateStaff />} />
            <Route path="/allstaff" element={<AllStaff />} />
            <Route path="/staffAttendence" element={<StaffAttendence />} />
          </Routes>
        </main>
      </div>

      <Footer />
    </div>
  );
};

export default AdminPage;
